import { Link, useLocation } from 'react-router-dom';

/**
 * UIHarnessNav - Navigation for UI Harness mode
 * 
 * Shows all available test routes and scenarios
 */
export default function UIHarnessNav() {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const routes = [
    { name: 'Dashboard', path: '/__ui-harness/dashboard', layout: 'App' },
    { name: 'Wallet', path: '/__ui-harness/wallet', layout: 'App' },
    { name: 'Campaigns', path: '/__ui-harness/campaigns', layout: 'App' },
    { name: 'Analytics', path: '/__ui-harness/analytics', layout: 'App' },
    { name: 'Customers', path: '/__ui-harness/customers', layout: 'App' },
    { name: 'Templates', path: '/__ui-harness/templates', layout: 'App' },
    { name: '---', path: null },
    { name: 'Admin: SMS Packs', path: '/__ui-harness/admin/sms-packs', layout: 'Admin' },
    { name: 'Admin: Promo Codes', path: '/__ui-harness/admin/promo-codes', layout: 'Admin' },
    { name: '---', path: null },
    { name: 'CW: Dashboard', path: '/__ui-harness/cw/dashboard', layout: 'CW' },
    { name: 'CW: Wallet', path: '/__ui-harness/cw/wallet', layout: 'CW' },
    { name: 'CW: Campaigns', path: '/__ui-harness/cw/campaigns', layout: 'CW' },
    { name: 'CW: Analytics', path: '/__ui-harness/cw/analytics', layout: 'CW' },
  ];

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg">
      <div className="container mx-auto px-4 py-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-yellow-300 rounded-full animate-pulse"></div>
              <span className="font-bold text-sm">UI HARNESS MODE</span>
            </div>
            <span className="text-xs opacity-75">No Auth • Mock Data • Safe to Delete</span>
          </div>
          
          <div className="flex items-center gap-2">
            <select 
              className="text-xs bg-white/20 border border-white/30 rounded px-2 py-1 text-white"
              onChange={(e) => window.location.href = e.target.value}
              value={location.pathname}
            >
              <option value="" className="text-gray-900">Select Page...</option>
              {routes.map((route, idx) => 
                route.path ? (
                  <option key={idx} value={route.path} className="text-gray-900">
                    {route.name} ({route.layout})
                  </option>
                ) : (
                  <option key={idx} disabled className="text-gray-400">
                    ────────
                  </option>
                )
              )}
            </select>
            
            <Link 
              to="/" 
              className="text-xs bg-white/20 hover:bg-white/30 px-3 py-1 rounded border border-white/30"
            >
              Exit Harness →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
